var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-player-container"},[(_vm.audioSources.length)?_c('insight-landing-player',{ref:"insigthPlayer",attrs:{"sources":_vm.selectedAudio,"html5":""},on:{"end":_vm.onPlaybackEnd,"load":_vm.onLoad,"play":_vm.onPlay,"pause":_vm.onPause}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }